import { DbetSingleton } from 'utils';

const dbet = DbetSingleton.getInstance();

export const checkNumber = number => {
  const regexp = /^[0-9]+([.][0-9]*)?|[.][0-9]$/;
  return regexp.test(number);
};

export const checkWithdraw = value =>
  !/^(0(\.0*)?|[1-9][0-9]*\.?[0-9]*|0\.[0-9]*[1-9]?)$/.test(value);

export const checkUsernameValidity = value => new RegExp(dbet.usernameRegEx()).test(value);
export const checkPasswordValidity = value => new RegExp(dbet.passwordRegEx(), 'g').test(value);

export const DEVICES_REGEXP = {
  ios: /iPad|iPhone|iPod/i,
  android: /Android/i,
  mac: /Macintosh/i,
  windowsPhone: /windows phone/i,
  windows: /Windows/i,
  ubuntu: /Ubuntu/i,
  mobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i,
};
